import { HiTrash } from "react-icons/hi2";

export const DeleteIcon = ({ width, height, color, ...props }) => (
  <HiTrash
    size={width || height || 20}
    color={color || "currentColor"}
    {...props}
  />
);
